import React, { useState } from "react";

import {
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  Tabs,
  Tab,
  IconButton,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";

import { Button as LoadingButton } from "@mui/material";
import Iconify from "../../components/Iconify";
import CopyClipboard from "../../components/CopyClipboard";
import CreateImage from "../../playcreator/components/CreateImage";

export default function ViewerShareDialog(props) {
  const [tabIndex, setTabIndex] = useState(0);
  const [showTitle, setShowTitle] = useState("1");
  const [showDescription, setShowDescription] = useState("1");
  const [showVideo, setShowVideo] = useState("1");
  const [showPhaseDescriptions, setShowPhaseDescriptions] = useState("1");

  let { settings, phases, dbData } = props;

  const { shareableLinkCode } = props;

  return (
    <Dialog
      sx={{ fontSize: 16 }}
      fullWidth={true}
      maxWidth={"sm"}
      open={props.open}
      onClose={props.onClose}
    >
      {props.onClose ? (
        <IconButton
          aria-label="close"
          onClick={props.onClose}
          sx={{
            zIndex: 10000,
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Iconify icon={"eva:close-fill"} />
        </IconButton>
      ) : null}

      <DialogTitle>
        <Tabs
          variant="scrollable"
          value={tabIndex}
          onChange={(x, value) => {
            setTabIndex(Number(value));
          }}
        >
          <Tab
            sx={{
              "&:focus , &:hover": {
                color: "inherit!important",
                backgroundColor: "inherit!important",
              },
              px: 2,
              mr: "10px !important",
              fontSize: 16,
            }}
            label="Link"
          />
          <Tab
            sx={{
              "&:focus , &:hover": {
                color: "inherit!important",
                backgroundColor: "inherit!important",
              },
              px: 2,
              mr: "10px !important",
              fontSize: 16,
            }}
            label="Images"
          />
          <Tab
            sx={{
              "&:focus , &:hover": {
                color: "inherit!important",
                backgroundColor: "inherit!important",
              },
              px: 3,
              mr: "10px !important",
              fontSize: 16,
            }}
            label="Embed"
          />
        </Tabs>
      </DialogTitle>
      <DialogContent dividers>
        {tabIndex === 0 && (
          <Box sx={{}}>
            <Typography gutterBottom variant="subtitle2">
              Copy & Paste this link to share the play
            </Typography>

            <Box sx={{ mb: 2 }}></Box>

            <CopyClipboard
              sx={{ "& input": { fontSize: 14 } }}
              value={`${process.env.REACT_APP_PUBLIC_API}/playcreator/viewer?code=${shareableLinkCode}`}
            />
          </Box>
        )}

        {tabIndex === 1 && (
          <CreateImage
            data={{
              title: dbData.title,
              phases: phases,
              settings: settings,
            }}
          />
        )}

        {tabIndex === 2 && (
          <div>
            <Typography sx={{ mt: 2 }} variant="subtitle2">
              Copy & Paste the code below to embed the play into your web page.
            </Typography>

            <textarea
              style={{
                width: "100%",
                fontSize: 14,
                padding: 15,
                marginTop: 20,
              }}
              rows={4}
              value={`<iframe style="border:0" title="Play Creator App" width="800" height="500" src='https://www.thehoopsgeek.com/react-apps/PlayCreator/embed/?code=${shareableLinkCode}&showTitle=${showTitle}&showVideo=${showVideo}&showDescription=${showDescription}&showPhaseDescriptions=${showPhaseDescriptions}'></iframe>`}
            />

            <Stack direction="row" sx={{ mt: 4 }} spacing={2}>
              <FormControl size="small">
                <InputLabel id="select-title-label">Title</InputLabel>
                <Select
                  labelId="select-title-label"
                  id="select-title"
                  value={showTitle}
                  label="Title"
                  onChange={(x) => setShowTitle(x.target.value)}
                >
                  <MenuItem value={"1"}>Yes</MenuItem>
                  <MenuItem value={"0"}>No</MenuItem>
                </Select>
              </FormControl>

              <FormControl size="small" sx={{ width: 100 }}>
                <InputLabel id="select-description-label">
                  Description
                </InputLabel>
                <Select
                  labelId="select-description-label"
                  id="select-description"
                  value={showDescription}
                  label="Description"
                  onChange={(x) => setShowDescription(x.target.value)}
                >
                  <MenuItem value={"1"}>Yes</MenuItem>
                  <MenuItem value={"0"}>No</MenuItem>
                </Select>
              </FormControl>

              <FormControl size="small" sx={{ width: 140 }}>
                <InputLabel id="select-frame-label">
                  Frame Description
                </InputLabel>
                <Select
                  labelId="select-frame-label"
                  id="select-frame"
                  value={showPhaseDescriptions}
                  label="Frame Description"
                  onChange={(x) => setShowPhaseDescriptions(x.target.value)}
                >
                  <MenuItem value={"1"}>Yes</MenuItem>
                  <MenuItem value={"0"}>No</MenuItem>
                </Select>
              </FormControl>

              <FormControl size="small" sx={{ width: 100 }}>
                <InputLabel id="select-video-label">Video</InputLabel>
                <Select
                  labelId="select-video-label"
                  id="select-video"
                  value={showVideo}
                  label="Video"
                  onChange={(x) => setShowVideo(x.target.value)}
                >
                  <MenuItem value={"1"}>Yes</MenuItem>
                  <MenuItem value={"0"}>No</MenuItem>
                </Select>
              </FormControl>
            </Stack>

            <Box sx={{ overflow: "hidden", width: "100%", pt: 2 }}>
              <iframe
                key={`https://www.thehoopsgeek.com/react-apps/PlayCreator/embed/?code=${shareableLinkCode}&showTitle=${showTitle}&showVideo=${showVideo}&showDescription=${showDescription}&showPhaseDescriptions=${showPhaseDescriptions}`}
                title="Play Creator"
                width="800"
                height="600"
                src={`https://www.thehoopsgeek.com/react-apps/PlayCreator/embed/?code=${shareableLinkCode}&showTitle=${showTitle}&showVideo=${showVideo}&showDescription=${showDescription}&showPhaseDescriptions=${showPhaseDescriptions}`}
              />
            </Box>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
